import { graphql } from 'generated/gql/account-manager';

const sitesQueryDocument = graphql(`
  query sites {
    sites {
      id
      accountId
      accountName
      platformSiteId
      name
      targetLeadType
      subdomain
      mappedDomain
    }
  }
`);

const sitesVisitorsQueryDocument = graphql(`
  query sitesVisitors($days: Int!) {
    siteDashboardVisitor(days: $days) {
      visitorTotalPerSite {
        subdomain
        visitors
        previousVisitors
      }
    }
  }
`);

const accountsQueryDocument = graphql(`
  query accounts {
    accounts {
      id
      name
      onboardingStatus
    }
  }
`);

export {
  sitesQueryDocument,
  sitesVisitorsQueryDocument,
  accountsQueryDocument,
};
